import { withContentRequest } from '@/utils/contentLoading.mjs'
import axios from "axios";
import config from "@/http/config/axiosJsonConfig";
import { attachInterceptors } from "@/http/config/interceptors";

function $axiosJson(options) {
  return withContentRequest(options, (requestConfig, requestContext) => {
    const instance = axios.create({
      baseURL: config.baseUrl,
      headers: { ...axios.defaults.headers.common, ...config.headers },
      timeout: config.timeout,
      withCredentials: config.withCredentials,
      responseType: requestConfig.responseType || config.responseType
    });
    attachInterceptors(instance, { ...requestConfig, requestContext }, "data");
    return instance(requestConfig);
  })
}

export default $axiosJson;
